import { useState, useEffect } from 'react';
import { fetchAllBabies } from '../services/api';

const useApiBabies = () => {
  const [apiBabies, setApiBabies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadBabies = () => {
    setLoading(true);
    setError(null);
    fetchAllBabies()
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        setApiBabies(list);
      })
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadBabies(); }, []);

  return { apiBabies, loading, error, refetch: loadBabies };
};

export default useApiBabies;